// polyfills
// import 'babel-polyfill'
import 'core-js/fn/array/flatten'
import 'core-js/fn/string/ends-with'
import 'core-js/fn/string/starts-with'
import 'core-js/fn/array/includes'

// icons
import '@fortawesome/fontawesome-free/css/solid.min.css'

// 3rd-party components
import Vue from "vue"
import Rollbar from 'vue-rollbar'
import PortalVue from 'portal-vue'
import VModal from 'vue-js-modal'
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import VueAxios from 'vue-axios'
import GlobalEvents from 'vue-global-events'
import Notifications from 'vue-notification'
import VueCompositionApi from '@vue/composition-api'
import Vue2TouchEvents from 'vue2-touch-events'

// register globally
Vue.component('GlobalEvents', GlobalEvents)

// application
import App from "./App.vue"
import store from "./store"
import i18n from './i18n'
import router from './router'
import { ShopApiClientVuePlugin } from '@/utils/shop-api-client'
import { DeviceDetectionProvider } from '@/utils/device-detection-provider'
import { PathPrefixPlugin } from '@/utils/path-prefix-plugin'

// configure axios to be able to use it in the store
const cacheConfig = {
  enabledByDefault: true
}

if (process.env.NODE_ENV === 'production')
  axios.defaults.adapter = cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig)

Vue.use(VueAxios, axios)
Vue.use(VModal, { dialog: true, clickToClose: false, dynamic: true })
Vue.use(Notifications)
Vue.use(VueCompositionApi)
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 100
})

// expose the  shop api as $shopApiClient
Vue.use(ShopApiClientVuePlugin)
// expose $runtimeEnvironment globally
Vue.use(DeviceDetectionProvider)
// expose $pathPrefix
Vue.use(PathPrefixPlugin)

// expose Vue.$rollbar
Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_POST_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true, //process.env.NODE_ENV=== 'production',
  source_map_enabled: true,
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0'
      }
    }
  }
})


// fix IE11 SVGElement not having getEleemntsByClassName
if (SVGElement.prototype.getElementsByClassName === undefined) {
  SVGElement.prototype.getElementsByClassName = function(className) {
      return this.querySelectorAll('.' + className);
  };
}

// set error handling to be intercepted by rollbar
if ( process.env.NODE_ENV === 'production' )
  Vue.config.errorHandler = (err) => Vue.rollbar.error(err)

Vue.use(PortalVue)

// register a vue filter to break new lines to <br/>
Vue.filter('breakify', (value) => {
  if (!value) return ''
  return value.toString().replace(/\n/gim, '<br />')
})

Vue.config.productionTip = false

// fix missing ParamterValues to be displayed as is
// eslint-disable-next-line
i18n.missing = (locale, key, _vm, _values) => {
  if(key && key.indexOf('parameterValues.') == 0) {
    Vue.rollbar.warn(`[ParamterValues Translation missing] '${key}'' in locale '${locale}'.`)
    return key
      .replace('parameterValues.', '')
      .replace('>/=', '≥')
      .replace('>/=', '≥')
      .replace('</=', '≤')
  }

  return key
}


new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
  created() {
    const html = document.documentElement // returns the html tag
    let lang = html.getAttribute('lang')
    // eslint-disable-next-line
    // console.log(lang)
    this.$i18n.locale = lang
  }
}).$mount("#app", /* hydrating - receiving data-* attributes from template */ true)
